/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, NgZone } from '@angular/core';
import { MainMenuService } from '../services/mainmenu.service';
import { Router } from '@angular/router';

@Component({
  selector: 'main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  providers: [MainMenuService]
})
export class MainMenuComponent implements OnInit {
  public menuItems: Array<any> = [];

  constructor(private mainMenuService: MainMenuService, private router: Router, private zone: NgZone) {}

  ngOnInit(): void {
    this.getMenuItems();
  }

  public highlightSelectedPrimaryMenu(menuToBeHighlighted: any) {
    for (const item of this.menuItems) {
      if (item.menu_title === menuToBeHighlighted.menu_title) {
        item['isSelected'] = true;
      } else {
        item['isSelected'] = false;
      }
    }
  }

  public redirectTo(menu: any, subMenu?: any) {
    let route = '/',
      menuToBeSelected = menu,
      menuToBeBeRedirectedTo;
    menuToBeSelected = menu;
    if (subMenu) {
      menuToBeBeRedirectedTo = subMenu;
    } else {
      if (menu.subItems.length > 0) {
        return false;
      } else {
        menuToBeBeRedirectedTo = menu;
      }
    }
    this.highlightSelectedPrimaryMenu(menuToBeSelected);
    route = this.getRouteFromSelectedMenu(menuToBeBeRedirectedTo);
    route === '/' ? (route = '**') : route;
    this.zone.run(() => {
      this.router.navigate([route]);
    });
  }

  public getRouteFromSelectedMenu(menu: any): string {
    let route = '/';
    const link = menu.menu_link;
    if (link.split('#').length > 1) {
      route = link.split('#')[1];
    }
    return route;
  }

  private getMenuItems() {
    this.mainMenuService
      .getMenuItems()
      .then(this.getMenuItemsSuccessHandler.bind(this), this.getMenuItemFailureHandler.bind(this));
  }

  private getMenuItemsSuccessHandler(data: any) {
    this.menuItems = data;
  }

  private getMenuItemFailureHandler(err: Error) {
    console.error('Error @ main-menu.componnet/getMenuItems: ', err);
  }
}
